import { type Epic, combineEpics } from 'redux-observable';
import { filter, mergeMap } from 'rxjs';
import { request } from '@/core';
import { openSnackbar } from '@/core/features/snackbar';
import { changePasswordRequest } from '@/api/user';
import { navigate } from '@/slices/app';
import i18n from '@/i18n';
import { changePassword } from '../actions';

const changePasswordEpic: Epic = (action$) =>
  action$.pipe(
    filter(changePassword.match),
    request(({ payload }) => changePasswordRequest(payload), changePassword),
  );

const changePasswordSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(changePassword.succeeded.match),
    mergeMap(() => [
      navigate({ to: '/auth/login' }),
      openSnackbar({
        snackbarType: 'success',
        snackbarMessage: i18n.t('CHANGE_PASSWORD_SUCCESS'),
      }),
    ]),
  );

export default combineEpics(changePasswordEpic, changePasswordSucceededEpic);
